export default function () {
  /**
   * @type {*|[]|NodeListOf<HTMLElementTagNameMap[string]>|NodeListOf<Element>|
   * NodeListOf<SVGElementTagNameMap[string]>}
   */
  const appearedElement = document.querySelectorAll('.c-appeared');

  /**
   * appearedEffectClass
   * @type {string}
   */
  const appearedEffectClass = 'c-appeared--done';

  /**
   * Option
   * @type {{threshold: number}}
   */

  const options = {
    threshold: 0.25,
  };

  /**
   * observer
   * @type {IntersectionObserver}
   */
  const appearedObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add(appearedEffectClass);
        appearedObserver.unobserve(entry.target);
      }
    });
  }, options);

  /**
   * Observe targets
   * @return void
   */
  appearedElement.forEach((target) => {
    appearedObserver.observe(target);
  });
}
